import { useEffect, useRef } from "react";
import twemoji from "twemoji";
import { isAppleBrowser, isWindowsBrowser } from "../../utils/platform";

function getResolvedEmoji(emoji) {
  return String(emoji || "").trim();
}

export function EmojiSymbol({ emoji, className = "", label, ariaHidden = true }) {
  const resolvedEmoji = getResolvedEmoji(emoji);
  const emojiRef = useRef(null);
  const shouldUseNativeEmoji = isAppleBrowser() || !isWindowsBrowser();

  useEffect(() => {
    if (shouldUseNativeEmoji || !emojiRef.current) {
      return;
    }

    emojiRef.current.innerHTML = resolvedEmoji
      ? twemoji.parse(resolvedEmoji, {
          folder: "svg",
          ext: ".svg",
        })
      : "";
  }, [resolvedEmoji, shouldUseNativeEmoji]);

  if (!resolvedEmoji) {
    return null;
  }

  if (shouldUseNativeEmoji) {
    return (
      <span
        className={`inline-flex items-center justify-center align-middle leading-none ${className}`.trim()}
        aria-hidden={ariaHidden}
        aria-label={ariaHidden ? undefined : label}
      >
        {resolvedEmoji}
      </span>
    );
  }

  return (
    <span
      ref={emojiRef}
      className={`inline-flex items-center justify-center align-middle leading-none ${className}`.trim()}
      aria-hidden={ariaHidden}
      aria-label={ariaHidden ? undefined : label}
    >
      {resolvedEmoji}
    </span>
  );
}
